// KAN-81: ticket links in the reports change color once clicked, so a reader can see what they
// have already gone through. Ticket numbers are clickable spans (not real links), so the browser's
// :visited state doesn't apply; the clicked numbers are kept here instead.
//
// One list per signed-in user, in this browser only (localStorage). The state is reactive: a view
// that calls isTicketVisited() while rendering re-renders when a ticket is marked.
import { reactive } from 'vue'

const KEY_PREFIX = 'teamwrkr-visited-tickets:'
const MAX_TICKETS = 2000
const TTL_MS = 90 * 24 * 60 * 60 * 1000

const state = reactive({ owner: null, visited: {} })

function storageKey(owner) {
  return `${KEY_PREFIX}${owner}`
}

function save() {
  if (!state.owner) return
  try {
    const entries = Object.entries(state.visited)
      .sort((a, b) => b[1] - a[1])
      .slice(0, MAX_TICKETS)
    localStorage.setItem(storageKey(state.owner), JSON.stringify(Object.fromEntries(entries)))
  } catch (err) {
    // Storage blocked (private mode etc.): the marks last for this page only.
  }
}

// Switches to the given user's list (no-op when it's already loaded).
export function loadVisitedTickets(owner) {
  const key = owner ? String(owner) : null
  if (key === state.owner) return
  state.owner = key
  const visited = {}
  if (key) {
    try {
      const parsed = JSON.parse(localStorage.getItem(storageKey(key)) || '{}')
      const cutoff = Date.now() - TTL_MS
      for (const [nbr, at] of Object.entries(parsed || {})) {
        if (Number(at) >= cutoff) visited[nbr] = Number(at)
      }
    } catch (err) {
      // Unreadable or blocked storage: start empty.
    }
  }
  state.visited = visited
}

export function markTicketVisited(ticketNbr) {
  if (ticketNbr === null || ticketNbr === undefined || ticketNbr === '') return
  state.visited = { ...state.visited, [String(ticketNbr)]: Date.now() }
  save()
}

export function isTicketVisited(ticketNbr) {
  return Boolean(state.visited[String(ticketNbr)])
}

// The class list for a ticket-ref span.
export function ticketRefClass(ticketNbr) {
  return isTicketVisited(ticketNbr) ? 'ticket-ref ticket-ref--visited' : 'ticket-ref'
}
